import styled from 'styled-components';

const RatingAverageContainer = styled.div`
  display: flex;
  flex-direction: column;
  font-weight: normal;
  justify-content: center;
  align-items: center;
  border: 1px solid #e9e9e9;
  border-radius: 8px;
  margin-bottom: 12px;
  width: 100%;
`;

const RatingAverageStyle = styled.span`
  font-style: normal;
  font-weight: 700;
  font-size: 40px;
  line-height: 100%;
  display: flex;
  align-items: flex-end;
  color: #282828;
`;

const RatingContent = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 16px;

  & span {
    font-size: 12px;
  }
`;

const Hr = styled.hr`
  border: none;
  border-bottom: 1px solid #e9e9e9;
  width: 100%;
`;

const CardAverageWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 16px;
`;

const TextBox = styled.div`
  display: flex;
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 100%;
  color: #575757;
  width: 100%;
  background: #fafafa;
  padding: 16px;
`;

const Wrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  padding: 16px 17px 12px 14px;
`;

export default RatingAverageContainer;
export { RatingAverageContainer, RatingAverageStyle, RatingContent, Hr, CardAverageWrapper, TextBox, Wrapper };
